
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import { IRootState } from "@/store/types";

export default Vue.extend({
  data() {
    return {
      percent: 0,
      show: false,
      canSuccess: true,
      duration: 5000,
      height: "3px",
      color: "#ffa13a",
      failedColor: "red",
      timer: undefined as any,
      cut: undefined as any
    };
  },
  computed: {
    ...mapState({
      applicationIsLoading: (state: IRootState) => state.application.isLoading,
      uiIsLoading: (state: IRootState) => state.ui.isLoading,
      promoOfferIsLoading: (state: IRootState) => state.promoOffer.isLoading,
      referenceDataIsLoading: (state: IRootState) =>
        state.referenceData.isLoading,
      standardOfferIsLoading: (state: IRootState) =>
        state.standardOffer.isLoading
    }),
    isLoading(): boolean {
      return (
        (this as any).uiIsLoading ||
        (this as any).promoOfferIsLoading ||
        (this as any).referenceDataIsLoading ||
        (this as any).standardOfferIsLoading ||
        (this as any).applicationIsLoading
      );
    }
  },
  watch: {
    isLoading(value) {
      if (value) {
        this.start();
      } else {
        this.finish();
      }
    }
  },
  methods: {
    start() {
      this.show = true;
      this.canSuccess = true;
      if (this.timer) {
        clearInterval(this.timer);
        this.percent = 0;
      }
      this.cut = 10000 / Math.floor(this.duration);
      this.timer = setInterval(() => {
        this.increase(this.cut * Math.random());
        if (this.percent > 95) {
          this.finish();
        }
      }, 100);
      return this;
    },
    set(num: number) {
      this.show = true;
      this.canSuccess = true;
      this.percent = Math.floor(num);
      return this;
    },
    get() {
      return Math.floor(this.percent);
    },
    increase(num: number) {
      this.percent = this.percent + Math.floor(num);
      return this;
    },
    decrease(num: number) {
      this.percent = this.percent - Math.floor(num);
      return this;
    },
    finish() {
      this.percent = 100;
      this.hide();
      return this;
    },
    pause() {
      clearInterval(this.timer);
      return this;
    },
    hide() {
      clearInterval(this.timer);
      this.timer = undefined;
      setTimeout(() => {
        this.show = false;
        Vue.nextTick(() => {
          setTimeout(() => {
            this.percent = 0;
          }, 200);
        });
      }, 500);
      return this;
    },
    fail() {
      this.canSuccess = false;
      return this;
    }
  }
});
